<script setup>
import { BAccordion, BAccordionItem } from 'bootstrap-vue-next';

import MarkdownRenderer from '~/common/components/MarkdownRenderer.vue';

import detailsMarkdown from './DetailsSection.md?raw';
</script>

<template>
  <BAccordion class="mb-2">
    <BAccordionItem
      title="Details"
      :visible="false"
    >
      <MarkdownRenderer
        class="overflow-auto"
        :markdown-content="detailsMarkdown"
      />
    </BAccordionItem>
  </BAccordion>
</template>
